<template>
    <div></div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
    name: "Auth",
    beforeMount() {
        const query = this.$router.currentRoute.query || {}
        const redirectUrl = query.redirectUrl
        const token = query.accessToken
        if (token && token.length > 0) {
            this.$store.commit('SET_USER_TOKEN', { token})
        } else {
            Cookies.remove('authed', { path: '/'})
        }
        setTimeout(()=> {
            if (redirectUrl && redirectUrl.length > 0) {
                return location.href = redirectUrl
            } else {
                return location.href = '/'
            }
        }, 200)
    }
}
</script>

